import '../../resources/css/settings/AccountForm.scss';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field, getFormValues, reduxForm} from 'redux-form';
import {Button, Col, Row} from 'react-bootstrap';
import {checkTableAuth} from '../../components/common/access-auth';
import {commonRenderInput, commonRenderSwitch} from '../../components/common/access-form';
import {
    maxLength256,
    maxLength32, minLength8,
    verifyForm,
    verifyNumber
} from '../../components/common/access-form-validation';
import {
    doGetAccountDetail,
    doGetNotifySettings,
    doSaveAccountDetail,
    SAVE_SETTING_ACCOUNT_DETAIL_FAIL,
    SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS
} from '../../actions/settings/index';
import {loadAccountRoleList} from '../../actions/account/index';
import {dateFormatter} from '../common/access-form';
import {
    closeModal,
    MODAL_PICK_SAVE,
    openModalAlert,
    openModalTip,
    openPickModal,
    popupModalConfirm
} from '../../actions/index';
import Loading from '../../components/common/Loading';

class AccountForm extends Component {

    submitType = null

    state = {
        popLoading: true
    }
    
    formSubmit = (values, action, props) => {
        const { verifyFormPass, authToken, popupModalConfirm, isAdd, accountRole, roleTableAuth, doSaveAccountDetail, selectSite, openModalAlert, accountDetail, accountInfo, smtpSetting } = this.props;
        let errLog = "";
        const isSelf = accountDetail ? accountDetail.seq === accountInfo.seq : false;

        if (checkTableAuth('settings', accountRole, roleTableAuth, 2)) {
            if (verifyFormPass) {
                let type;
                if (isAdd) {
                    type = 'add';
                } else {
                    type = 'edit';
                }
    
                let objBody = {
                    account : values.email,
                    name : values.name,
                    email: values.email,
                    enabled : values.enabled === 1,
                    roleId : values.roleId,
                    failsCount : values.failsCount,
                    lockLogin : values.lockLogin === 1,
                    organization : selectSite
                };
    
                if (!isAdd) {
                    objBody['seq'] = accountDetail.seq;
                }

                if (values.isResetPwd) {
                    if (values.password) {
                        objBody['password'] = values.password;
                    } else {
                        errLog += "Please input new password.\n";
                    }                    
                }
    
                if (errLog) {
                    openModalAlert(errLog);
                } else {
                    if (isAdd) {
                        const message = !smtpSetting ?  "Confirm to save?" : "'Notification Settings' has not been configured. Do you still want to create this account?";
                        popupModalConfirm('Confirm', 'icon-alert', message, 300, () => doSaveAccountDetail(authToken, type, objBody, isSelf), null, false);
                    }else {
                        popupModalConfirm('Confirm', 'icon-alert', "Confirm to save?", 300, () => doSaveAccountDetail(authToken, type, objBody, isSelf), null, false);
                    }
                }
            } else {
                openModalAlert("Sorry, field need to fill.");
            }
        } else {
            openModalAlert("Sorry, you don't have permission to change config.");
        }
    }

    checkedCheckbox = (fieldName) => {
        const { formValues, change, isReadonly } = this.props;
        if (!isReadonly) {
            const doCheck = formValues[fieldName] !== 1 ? 1 : 0;
            change(fieldName, doCheck);
        }
    }

    loadData = () => {
        const { change, accountDetail, timeZoneID } = this.props;
        
        if (accountDetail) {
            change('account', accountDetail.account);
            change('name', accountDetail.name);
            change('email', accountDetail.email);
            change('enabled', accountDetail.enabled ? 1 : 0);
            change('roleId', accountDetail.roleId);
            change('roleName', accountDetail.roleName);
            change('failsCount', accountDetail.failsCount);
            change('lockLogin', accountDetail.lockLogin ? 1 : 0);
            change('lockLoginDate', dateFormatter(accountDetail.lockLoginDate, timeZoneID));
            change('lastLoginDate', dateFormatter(accountDetail.lastLoginDate, timeZoneID));
            change('expirationDate', dateFormatter(accountDetail.expirationDate, timeZoneID));
            change('groupId', accountDetail.groupId);
            change('groupName', accountDetail.groupName);
        }

        this.setState({
            popLoading: false
        });
    }    

    pickupRole = () => {
        const { loadAccountRoleList, openPickModal, authToken, selectSite, modalMessage } = this.props;
        if(modalMessage !== 'view'){
            openPickModal("PickRole", () => loadAccountRoleList(authToken, selectSite ? selectSite : -1));
        }
    }

    pickupGroup = () => {
        const { openPickModal, modalMessage } = this.props;
        if(modalMessage !== 'view'){
            openPickModal("PickGroup", null);
        }
    }

    componentDidUpdate (prevProps, prevState, snapshot) {
        const { accountDetail, loading, status, change, modalPick, closeModal, errMsg, openModalAlert, isAdd, openModalTip, smtpSetting } = this.props;
    
        if (prevProps.status !== status) {
          // if menu chagne size(mode), need redraw table
          if (status === SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS) {
            if (isAdd) {
                const message = !smtpSetting? 'Add Account is success, the server will send mail to notify new account.' : "Add Account is success.";
                openModalTip(message);
            } else {
                openModalTip('Save Account is success.');
            }            
            closeModal(null);
          } else if (status === SAVE_SETTING_ACCOUNT_DETAIL_FAIL) {
            if (errMsg) {
                openModalAlert(errMsg);
            }
            console.error("error", SAVE_SETTING_ACCOUNT_DETAIL_FAIL);            
          }
        }

        if (prevProps.accountDetail !== accountDetail) {
            if (accountDetail && !loading) {
                this.loadData();
            }
        }

        if (prevProps.modalPick.modalMessage !== modalPick.modalMessage) {
            if (modalPick.modalMessage === MODAL_PICK_SAVE) {
                if (modalPick.modalResult !== undefined && modalPick.modalResult !== null) {
                    if (modalPick.modalStatus === 'PickRole') {
                        change('roleId', modalPick.modalResult.seq);
                        change('roleName', modalPick.modalResult.name);
                    }

                    else if (modalPick.modalStatus === 'PickGroup') {
                        let groupId = '', groupName = '';
                        modalPick.modalResult.forEach(data => {
                            if (!groupId) {
                                groupId = data.seq;
                                groupName = data.name;
                            } else {
                                groupId += ',' + data.seq;
                                groupName += ',' + data.name;
                            }
                        });
                        change('groupId', groupId);
                        change('groupName', groupName);
                    }
                }
            }    
        }
    }

    componentDidMount() {
        // if call render will do this method
        const { selectAccount, modalMessage } = this.props;
        if(modalMessage !== 'add'){
            this.loadData();
        }else{
            // const { doGetNotifySettings, authToken, selectSite } = this.props;
            // doGetNotifySettings(authToken, selectSite);
        }
        if (selectAccount) {
            // doGetAccountDetail(authToken,  selectAccount.seq);            
        } else {
            this.setState({
                popLoading: false
            });
        }
    }

    render() {
        const { isAdd, closeModal, handleSubmit, modalMessage, isReadonly, verifyFormPass, formValues, accountDetail } = this.props;
        const { popLoading } = this.state;

        let cssDisplayEdit/*, selectCursor = '';   */
        let pwdLabelText = '';
        // let cssAddHide = '';
        if (isAdd) {
            cssDisplayEdit = '';
            pwdLabelText = 'Custom Password';
            // cssAddHide = 'no-display'
        } else if (modalMessage === 'edit') {
            cssDisplayEdit = '';
            pwdLabelText = 'Reset Password';
        } else {
            cssDisplayEdit = ' no-display';
            // selectCursor = ' view-cursor'
        }

        return (
            <div className='area-form form-custom'>                               
                <div className='settings-account-form'>
                    <form id="account-form" onSubmit={handleSubmit(this.formSubmit)}>
                        <div className='area-content area-divide-space'>
                            <div className='area-header'>
                                <span className='icon-internet icon-info'></span><label>Account</label>
                            </div>
                            <div className='area-body'>
                                <Row>
                                    {accountDetail?.seq === 1 &&
                                        <Col sm={6} >
                                            <div className='area-form-label'>
                                                <label className='need-star-label'>*</label><label>Account</label>
                                            </div>
                                            <div className='area-form-field'>
                                                <Field name='account' type="text" component={commonRenderInput} placeholder="Please input account" disabled={!isAdd}/>
                                            </div>
                                        </Col>
                                    }

                                    <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'>*</label><label>Email</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field id="account-form-email" name='email' type="text" component={commonRenderInput} placeholder="Please input email" validate={maxLength256} disabled={isReadonly} />
                                        </div>
                                    </Col>
                                    <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'>*</label><label>Name</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field id="account-form-name" name='name' type="text" component={commonRenderInput} placeholder="Please input name" validate={maxLength256} disabled={isReadonly} />
                                        </div>
                                    </Col>
                                    <Col sm={12} className={cssDisplayEdit}>                                        
                                        <div className='area-reset-password'>
                                            <Row>
                                                <Col sm={6} >
                                                    <div className='area-form-label'>
                                                        <label className='need-star-label'></label><label>{pwdLabelText}</label>
                                                    </div>
                                                </Col>
                                                <Col sm={6} >
                                                    <Field id="account-form-resetPwd" name="isResetPwd" component={commonRenderSwitch} customStyle='detail-form-switch detail-form-switch-info' callback={() => this.checkedCheckbox('isResetPwd')}/>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className={formValues && formValues.isResetPwd ? 'area-show' : 'no-display'}>
                                            <div className='area-form-field'>
                                                <Field id="account-form-password" name='password' type="text" component={commonRenderInput} placeholder="Please input password" validate={[minLength8, maxLength32]} />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col sm={12} className={cssDisplayEdit}>
                                        <div className='area-reset-password'>
                                            <Row>
                                                <Col sm={6} >
                                                    <div className='area-form-label'>
                                                        <label className='need-star-label'></label><label>Enable</label>
                                                    </div>
                                                </Col>
                                                <Col sm={6} >
                                                    <Field id="account-form-enable" name="enabled" component={commonRenderSwitch} customStyle='detail-form-switch detail-form-switch-info' callback={() => this.checkedCheckbox('enabled')}/>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    {/*<Col sm={12} >*/}
                                    {/*    <div className='area-form-label'>*/}
                                    {/*        <label className='need-star-label'>*</label><label>Groups</label>*/}
                                    {/*    </div>*/}
                                    {/*    <div className={'area-form-field' + selectCursor} onClick={()=> { this.pickupGroup()}}>*/}
                                    {/*        <Field name="groupId" type="hidden" component={commonRenderInput} disabled={false}/>*/}
                                    {/*        <Field name="groupName" type="text" component={commonRenderPicker} openPickup={this.pickupGroup} disabled={isReadonly} placeholder={"Select group"}/>*/}
                                    {/*    </div>*/}
                                    {/*</Col>*/}

                                    <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Role</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field id="account-form-role" name='roleName' type="text" component={commonRenderInput} placeholder="" disabled={true}/>
                                        </div>
                                    </Col>
                                    <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Fails Count</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field id="account-form-fail-count" name='failsCount' type="text" component={commonRenderInput} placeholder="(Default: 0)" disabled={true} validate={verifyNumber} />
                                        </div>
                                    </Col>
                                    <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Lock Login</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field id="account-form-lockLogin" name="lockLogin" component={commonRenderSwitch} customStyle='detail-form-switch detail-form-switch-info' callback={() => this.checkedCheckbox('lockLogin')}/>
                                        </div>
                                    </Col>
                                    <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Lock Login Date</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field id="account-form-lockLoginDate" name='lockLoginDate' type="text" component={commonRenderInput} placeholder="NA" disabled={true} />
                                        </div>
                                    </Col>
                                    <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Last Login Date</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field id="account-form-lastLoginDate" name='lastLoginDate' type="text" component={commonRenderInput} placeholder="NA" disabled={true} />
                                        </div>
                                    </Col>
                                    <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Expiration Date</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field id="account-form-expirationDate" name='expirationDate' type="text" component={commonRenderInput} placeholder="NA" disabled={true} />
                                        </div>
                                    </Col>                                    
                                </Row>
                            </div>
                        </div>
                        <div className={'area-btns' + cssDisplayEdit }>
                            <Row>
                                <Col sm={4}>
                                    <div className='area-btn-cancel'>
                                        <Button id="account-form-cancel" type="button" variant="primary" size="lg" onClick={() => closeModal(null)} block>
                                            <span>Cancel</span>
                                        </Button>
                                    </div>
                                </Col>
                                <Col sm={8}>
                                    <div className='area-btn-save'>
                                        <Button id="account-form-save" type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>
                                            <span>Save</span>
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </form>
                </div>
                <Loading loading={popLoading} center={true}></Loading>
            </div>
        )
    }
}

const getVerifiedField = () => {
    return ['name', 'email']
}

const mapStateToProps = (state, ownProps) => {
    const verifyFormPass = verifyForm(state.form['AccountForm'], getVerifiedField());
    const modalMessage = state.commonReducers.modalMessage;
    const isReadonly = modalMessage === 'view';
    const isAdd = modalMessage === 'add';
    const notifyDetail = state.settingsReducers.notifyDetail;
    const smtpSetting = notifyDetail == null || Object.keys(notifyDetail).length === 0;
    let ret = {
        authToken: state.loginReducers.authToken,
        accountRole: state.loginReducers.accountRole,
        accountInfo: state.loginReducers.accountInfo,
        roleTableAuth: state.loginReducers.roleTableAuth,
        timeZoneID: state.loginReducers.timeZoneID,
        loading: state.settingsReducers.loading,
        status: state.settingsReducers.status,
        modalPick: state.commonReducers.modalPick,
        selectAccount: state.settingsReducers.selectAccount,
        accountDetail: state.settingsReducers.accountDetail,
        errMsg: state.settingsReducers.errMsg,
        selectSite: state.siteReducers.selectSite,
        smtpSetting: smtpSetting,
        modalMessage: modalMessage,
        isReadonly: isReadonly,
        isAdd: isAdd,
        initialValues: {roleName: 'User', enabled: 1},
        verifyFormPass: verifyFormPass,
        formValues: getFormValues('AccountForm')(state)
    }

    return ret;
}

AccountForm = reduxForm({
    form: 'AccountForm',  // a unique identifier for this form
})(AccountForm)

export default connect(
    mapStateToProps,
    { closeModal, popupModalConfirm, doGetAccountDetail, doSaveAccountDetail, openPickModal, loadAccountRoleList, openModalAlert, openModalTip, doGetNotifySettings }
)(AccountForm)